import { useEffect } from 'react'
import { useState } from 'react';
import { cookiesKeyNames } from '@revbox/common-fe';
import { useCookiesContext } from '../contexts/CookiesContext';

const useShowCurrency = (user) => {
    const { getShowCurrency, updateCookiesProperty, getPathKey } = useCookiesContext();
    const [showCurrency, setShowCurrency] = useState(false);

    const handleDisplayCurrencyState = (e) => {
        const value = e.target.checked ? "1" : "0";
        setShowCurrency(value === "1")
        const pathKey = getPathKey();
    
        updateCookiesProperty(cookiesKeyNames.showCurrency, value, pathKey);
      }

    useEffect(() => {
        const cookiesShowCurrency = getShowCurrency();
        if (cookiesShowCurrency === "1") {
            setShowCurrency(true);
            return
        }
        if ([null, undefined, "0"].includes(cookiesShowCurrency)) {
            setShowCurrency(user.owner_id !== 67);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);
    return { showCurrency, handleDisplayCurrencyState }
}

export default useShowCurrency
